import { AfterViewInit, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { Models } from '@ibexfusion/models';

import { PageAction } from '../../../components/page-actions/page-actions.component';
import { CompositionTypeService } from '@services/composition-types/composition-type.service';

@Component({
    selector: 'app-create-composition-type',
    templateUrl: './create-composition-type.component.html',
    styleUrls: ['./create-composition-type.component.scss'],
    providers: [CompositionTypeService],
    standalone: false
})
export class CreateCompositionTypeComponent implements OnInit, AfterViewInit {

  public title = 'Create composition type';

  public pageActions: PageAction[];

  public isLoading: boolean;

  public compositionType: Models.CompositionType;

  @ViewChild('compositionTypeTitle') compositionTypeTitle: ElementRef;

  constructor(private router: Router, private compositionTypeService: CompositionTypeService) {
  }

  ngOnInit() {
    this.compositionType = new Models.CompositionType();
  }

  ngAfterViewInit() {
    this.compositionTypeTitle.nativeElement.focus();
  }

  public submit(): void {
    this.isLoading = true;
    this.compositionTypeService.create(this.compositionType).then(() => {
      return this.router.navigate(['composition-types']);
    });
  }

}
